import React from "react";
import { Card, CardBody, Stack, Text, Center, Divider, Heading, Progress } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { formatDate } from "../../utils/formatDate";
import {renderInterventionEtat, renderInterventionEtatProgress } from "../../utils/formatters";
import InterventionControls from "./InterControl";
import PropTypes from "prop-types";

const InterventionCard = ({ intervention, isAdmin, fetchInterventions }) => {
  InterventionCard.propTypes = {
    intervention: PropTypes.object.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    fetchInterventions: PropTypes.func.isRequired,
  };
  return (
    <Card w="80%" m={5} ml="auto" mr="auto">
      <Link to={`/Intervention/${intervention.intervention_id}`}>
        <CardBody>
          <Center>
            <Heading size="md">Nom : {intervention.intervention_name}</Heading>
          </Center>
          <Stack spacing={2} mt={5} mb={5}>
            <Text ml="auto" mr="auto">Description : {intervention.intervention_description}</Text>
            <Center>
              <Text>Num Devis : {intervention.intervention_numDevis}</Text>
              <Text ml="25%">Num Affaire : {intervention.intervention_numAffaire}</Text>
            </Center>
            <Text ml="auto" mr="auto">Date de début estimée : {formatDate(intervention.intervention_startdate)}</Text>
            <Text ml="auto" mr="auto">Date de fin estimée : {formatDate(intervention.intervention_enddate)}</Text>
            {intervention.GPA && <Text ml="auto" mr="auto">GPA : Oui</Text>}
            {intervention.GPA ? <Text ml="auto" mr="auto">Bon de commande  : {intervention.BDC}</Text> : null}
          </Stack>
          <Stack spacing={2}>
            <Progress value={renderInterventionEtatProgress(intervention.intervention_etat)} />
            <Text ml="auto">État :{renderInterventionEtat(intervention.intervention_etat)}</Text>
          </Stack>
        </CardBody>
      </Link>
      {isAdmin || intervention.intervention_etat !==-1 ? (
        <>
          <Divider />
          <InterventionControls intervention={intervention} isAdmin={isAdmin} fetchInterventions={fetchInterventions} />
        </>
      ) : null}
    </Card>
  );

};


export default InterventionCard;
